import mutations from './deletablePackages.mutations'
import actions from './deletablePackages.actions'
import getters from './deletablePackages.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
